import { LocationSVG } from '@/components/svg/location/location'
import s from './locations-list.module.scss'

type Props = {
  locations?: string[]
  iconProps?: React.SVGAttributes<SVGElement>
  textClassName?: string
  separator?: React.ReactNode
}

export const LocationsList = ({
  locations,
  iconProps,
  textClassName,
  separator = ', ',
}: Props) => {
  if (!locations || locations.length === 0) return null

  return (
    <div className={s.supplierCategory}>
      <LocationSVG {...iconProps} />{' '}
      {locations && locations.length > 0 && (
        <div className={textClassName}>
          {locations.slice(0, 3).map((loc, index) => (
            <span key={loc} className={s.locationText}>
              {loc}
              {index < 2 && index < locations.length - 1 ? separator : ''}
            </span>
          ))}
          {locations.length > 3 && ` + ${locations.length - 3} more`}
        </div>
      )}
    </div>
  )
}
